<template>
    <div class="instruction" style="z-index: 1000">
        <div class="item" v-if="stage === 'first'">
            <img src="http://source.weicistudy.com/draw/rule_2.png"/>
            <img style="margin-top: -1px" src="http://source.weicistudy.com/draw/rule_3.png"/>
        </div>
        <div v-else class="item">
            <img src="http://source.weicistudy.com/draw/second-rule.png" alt="">
        </div>
        <a href="javascript:;" @click="closeDialog">
            <img class="close"  style="z-index: 1000" src="http://source.weicistudy.com/draw/rule_close.png" alt="">
        </a>
    </div>
</template>

<script>
    export default {
        name: "ActivityRules",
        data () {
            return {
                scrollTop: 0
            }
        },
        props: {
            stage: {
                type: String,
                default: 'first'
            },
            state: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            closeDialog () {
                this.$emit('close')
            }
        },
        watch: {
            state () {
                if (this.state) {
                    document.body.style.overflow = 'hidden'
                    this.scrollTop = document.scrollingElement.scrollTop;
                } else {
                    document.body.style.overflow = 'auto';
                    document.scrollingElement.scrollTop = this.scrollTop;
                }
            }
        }
    }
</script>

<style scoped>
    .instruction {
        position: fixed;
        top:0;
        left:0;
        width: 100%;
        height: 100vh;
        overflow: scroll;
        background-color: #FD7759;
        z-index: 1000;
    }
    .instruction .item {
        width: 100%;
        padding: 0;
        margin: 0;
    }

    .instruction .item img {
        width: 100%;
        display: block;
    }
    .close {
        position: absolute;
        top: 10px;
        right:10px;
        width: 60px !important;
    }
</style>